<template>
  <div class="bg video-quiz-overlay">
    <div class="quiz">
      <div class="quiz-inner-cont">
        <el-button type="info" icon="el-icon-close" size="mini" circle @click="closeQuizModal" class="close-btn"></el-button>
        <div class="quiz-header">
          <span v-if="isMcq" class="quiz-main"><img src="../../../../assets/picture/done_all.png" class="mcq-img" /> Multiple choice question</span>
          <span v-else-if="isText" class="quiz-main"><img src="../../../../assets/picture/text_fields.png" class="txt-img" /> Text question</span>
          <div class="btn-row">
            <button v-if="isMcq && hasTrueOption && !isShowSolution" @click="handleShareSolution" class="share-solution">&#8593; Share solution</button>
            <button v-else-if="isMcq && hasTrueOption" @click="handleHideSolution" class="hide-solution">Hide solution</button>
            <button v-if="isMcq" @click="isResponse = false" class="btn-img">
              <img v-if="!isResponse" src="../../../../assets/picture/pie_chart-s.png" class="pie-img" />
              <img v-else src="../../../../assets/picture/pie_chart.png" class="pie-img" />
            </button>
            <button @click="isResponse = true" class="btn-img">
              <img v-if="!isMcq || isResponse" src="../../../../assets/picture/grid_on-s.png" class="grid-img" />
              <img v-else src="../../../../assets/picture/grid_on.png" class="grid-img" />
            </button>
          </div>
        </div>
        <MultipleChoiceQuestion v-if="isMcq && !isResponse" :selectedQuiz="selectedQuiz" :isShowSolution="isShowSolution" :maxStudentCount="maxStudentCount" />
        <TextChoiceQuestion v-if="!isMcq" :selectedQuiz="selectedQuiz" />
        <DashBoardReviewPage v-if="isResponse || !isMcq" :maxStudentCount="maxStudentCount" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from 'vue'
import MultipleChoiceQuestion from './MultipleChoiceQuestion.vue'
import TextChoiceQuestion from './TextChoiceQuestion.vue'
import DashBoardReviewPage from './DashBoardReviewPage.vue'
import store from '@/store'

const props = defineProps({
  selectedQuiz: {
    type: Object,
  },
  maxStudentCount: {
    type: Number,
  },
  handleModalClose: {
    type: Function,
  },
})

const hasTrueOption = computed(() => props.selectedQuiz?.options?.some(option => option.on))
const isMcq = computed(() => props.selectedQuiz?.type === 'choice')
const isText = computed(() => props.selectedQuiz?.type === 'text')
const isShowSolution = ref(false)
const isResponse = ref(false)
const shareVideoSolution = computed(() => store.state.teacher.shareVideoSolution)

watch(
  () => shareVideoSolution.value,
  (newVal, oldVal) => {
    isShowSolution.value = newVal
  }
)

watch(isMcq, (newMcq) => {
  if (!newMcq) {
    isResponse.value = true
  }
})

const closeQuizModal = () => {
  props.handleModalClose()
  isResponse.value = false
  isShowSolution.value = false
}

const sendShareSolution = async (isShare) => {
  try {
    const response = await App.service('auth').patch('syncTeacher', {
      commit: 'teacher/setShareVideoSolution',
      data: isShare,
    })
    store.dispatch('teacher/setShareVideoSolution', response.data)
  } catch (error) {
    console.error('Error in patch:', error)
  }
}

const handleShareSolution = () => {
  isShowSolution.value = true
  sendShareSolution(true)
}

const handleHideSolution = () => {
  isShowSolution.value = false
  sendShareSolution(false)
}
</script>

<style scoped>
.bg {
  position: fixed;
  left: 0;
  top: 48px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
}

.close-btn {
  width: 32px;
  position: relative;
  left: 98%;
  top: -15px;
  cursor: pointer;
}

.quiz {
  height: auto;
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 25px 30px;
  border-radius: 20px;
  width: 75%;
  height: 70%;
  backdrop-filter: blur(10px);
}

.quiz-inner-cont {
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;
}

.quiz-header {
  display: flex;
  justify-content: space-between;
  font-size: 1.4rem;
  font-weight: 700;
  padding-bottom: 1rem;
}

.quiz-main {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.4rem;
}

.mcq-img {
  background-color: #f6993f;
  border-radius: 50%;
}

.txt-img {
  background-color: #e3342f;
  border-radius: 50%;
}

.btn-row {
  display: flex;
  gap: 0.6rem;
}

.btn-img {
  background: none;
  border: none;
  cursor: pointer;
}

.pie-img {
  height: 25px;
}

.grid-img {
  height: 25px;
}

.share-solution {
  padding: 0.5rem 0.8rem;
  border-radius: 1rem;
  background-color: rgb(20, 142, 142);
  color: #fff;
}

.hide-solution {
  padding: 0.5rem 0.8rem;
  border-radius: 1rem;
  background-color: #fff;
  color: teal;
}
</style>
